import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Logger } from '../../generic/logging/default-log.service';
import { FilterService } from '../../generic/service/filter.service';
import { ProductService } from '../../generic/service/product.service';
import { UserService } from '../../generic/service/user.service';
import { RelatedProductsComponent } from './related.products.component';
import { LazyLoadDirective } from '../../generic/component/lazyload/ng-lazy-load.directive';
import { ProductItemGridComponent } from '../../generic/component/products/productitem.grid.component';

/**
 * Used to show alternative products when the current product is not available anymore
 *
 * @author Patrick van Zadel
 */
@Component({
    templateUrl: './alternative.products.component.html',
    selector: 'alternative-products',
    styleUrls: ['./alternative_grower.products.component.scss'],
    standalone: true,
    imports: [ProductItemGridComponent, LazyLoadDirective],
})
export class AlternativeProductsComponent
    extends RelatedProductsComponent
    implements OnInit {
    @Input() itemNo: string;
    @Input() potSizeFrom: string;
    @Input() potSizeTill: string;
    @Input() potHeightFrom: string;
    @Input() potHeightTill: string;

    filterStateUrl: string;
    productOverviewUrl: string;

    constructor(
        public productService: ProductService,
        public domElement: ElementRef,
        public filterService: FilterService,
        public router: Router,
        userService: UserService,
        public logger: Logger,
    ) {
        super(
            productService,
            domElement,
            filterService,
            router,
            userService,
            logger,
        );
    }

    ngOnInit() {
        // We set the properties in the ngOnInit method because somehow the @Input properties are not set yet when we put these properties
        // in the class directly. Where this.limit is being inherited from the parent class.
        this.filterStateUrl = `?includefeatures=false&pageSize=${this.limit}&page=1&itemNo=${this.itemNo}&potSizeFrom=${this.potSizeFrom}
				&potSizeTo=${this.potSizeTill}&heightFrom=${this.potHeightFrom}&heightTo=${this.potHeightTill}`;
        this.productOverviewUrl = `/products?itemNo=${this.itemNo}
		&potSizeFrom=${this.potSizeFrom}&potSizeTo=${this.potSizeTill}&heightFrom=${this.potHeightFrom}&heightTo=${this.potHeightTill}`;

        super.ngOnInit();
    }
}
